import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installConsoleLogCapture } from './utils/logService';
import './styles/sisdpDesignTokens.css';
import './assets/styles/index.css';
import './styles/serverPortal.css';
import { register } from './serviceWorkerRegistration';

register({
  onUpdate: (registration) => window.dispatchEvent(new CustomEvent('sisfol:service-worker-update', {
    detail: {registration},
  })),
});

installConsoleLogCapture();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
